import React from 'react'
import axios from 'axios'
import { useEffect, useState, useCallback } from 'react'
import { Button, TextInput, Select } from "flowbite-react";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon, TrashIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormResource from './FormResource';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import { HiOutlineDownload } from 'react-icons/hi';
import api from '../../lib/api';
import { downloadBlobResponse } from '../../lib/downloads';


const Resources = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [resourceId, setResourceId] = useState(null);
    const [resourceName,setResourceName] = useState("");
    const [resources, setResources] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [filteredResources, setFilteredResources] = useState([]);
    const [areas, setAreas] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedArea, setSelectedArea] = useState("");
    
    const openModal = (title,resourceId,editMode,resourceName) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setIsCreating(editMode);
        setResourceId(resourceId);
        setResourceName(resourceName);
    };

    const handleDownload = async (resource) => {
        if (Number(resource.filepath_type) === 1) {
            window.open(resource.filePath, "_blank");
            return;
        }

        setIsLoading(true);
        try {
            const response = await api.get(`/resource/${resource.id}/download`, {
                responseType: 'blob',
            });
            downloadBlobResponse(response, resource.fileName || 'recurso');
        } catch (error) {
            alert(error.response?.data?.message || 'No fue posible descargar el recurso');
        } finally {
            setIsLoading(false);
        }
    }

    const handleFormSubmit = async(data) => {
        
        let res_title = data.res_title == "";
        if(res_title){ alert("Ingrese el titulo del recurso"); return;}

        let area = data.res_area == "";
        if(area){ alert("Seleccione el area"); return;}

        if (res_pathtype === "0" && !res_file) {
            alert("Debe seleccionar un archivo");
            return;
        }

        if (res_pathtype === "1" && res_pathurl.trim() === "") {
            alert("Debe ingresar una URL");
            return;
        }

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}


        let description = data.res_description == "";
        if(description){ 
            if(!confirm("¿ Confirma la creación del recurso sin descripción ?")){
                return;
            }
        }

        setIsLoading(true);
        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resource/create`,
                data,
                {
                    withCredentials: true,
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                }
            );
            if(response.data.status){
              setResources([...resources, response.data.file]);
              alert("Archivo cargado correctamente");
            }else{
              alert("Problema al cargar el archivo intenta nuevamente");
            }
        } catch (error) {
            alert("error en el proceso: ",error);
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resource/${resourceId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );
            setResources(
                resources.map((resource) =>
                    resource.id === resourceId ? { ...resources, ...response2.data.resource } : resource
                )
            ); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('confirma la eliminación del recurso?');
        if (!confirma) return;
        
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resource/${id}/delete`,
                {
                    withCredentials: true,
                }
            );
            if(response.data.status){
              alert("Recurso eliminado correctamente");
            }else{
              alert("Problema al eliminar el recurso");
            }

            setResources(resources.filter((resource) => resource.id !== id));
            //setToastShow(true)

        }catch(error){
            
        }
    }

    const clearFilters = () => {
        setSearchTerm("");
        setSelectedArea("");
    };

    useEffect(()=>{

        const getAreas = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/areas`,
                    {
                        withCredentials: true,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de áreas');
                }

                setAreas(response.data);
            } catch (error) {
                console.error('Error al cargar áreas:', error);
            } finally{
                setIsLoading(false);
              }
          }

        const getResources = async () => {
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/resources`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setResources(response.data);
            } catch (error) {
                setError(error.message);
            }
        }
        getAreas();
        getResources();
    }, []);

    useEffect(() => {
        let filtered = resources;

        // Filtrar por término de búsqueda
        if (searchTerm.trim() !== "") {
            filtered = filtered.filter(resource => 
                resource.fileName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                resource.observation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                resource.area?.name?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filtrar por área seleccionada
        if (selectedArea !== "" && selectedArea !== "all") {
            filtered = filtered.filter(resource => 
                resource.area?.name?.toString() === selectedArea
            );
        }

        setFilteredResources(filtered);
    }, [resources, searchTerm, selectedArea]);

    return (
        <>
            <div className="p-2 mt-4">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-xl px-3">Centro de recursos</h1>
                    {error && <div className="text-red-500 px-3 mb-4">{error}</div>}
                    <PermissionWrapper requiredPermissions={['resource_upload']}>
                        <Button className="text-gray-600" onClick={()=>openModal("Carga de recursos",null,true)} color='gray'>
                            Cargar
                        </Button>
                    </PermissionWrapper>
                </div>
                <div className="flex">
                    <div className="mb-4 px-3">
                        <TextInput
                            type="text"
                            placeholder="Buscar recursos por nombre, descripción o área..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            icon={MagnifyingGlassIcon}
                            className="w-full"
                        />
                    </div>
                    <div className="mb-4 px-3">
                        <Select
                            value={selectedArea}
                            onChange={(e) => setSelectedArea(e.target.value)}
                        >
                            <option value="">Todas las áreas</option>
                            {areas.map((area) => (
                                <option key={area.id} value={area.name.toString()}>
                                    {area.name}
                                </option>
                            ))}
                        </Select>
                    </div>
                    {(searchTerm || selectedArea) && (
                        <Button 
                            color="light" 
                            size="sm"
                            onClick={clearFilters}
                            className="whitespace-nowrap"
                        >
                            Limpiar filtros
                        </Button>
                    )}
                </div>
                <div className="px-3 mb-2 text-sm text-gray-600">
                    {filteredResources.length === resources.length 
                        ? `${resources.length} recurso${resources.length !== 1 ? 's' : ''} total${resources.length !== 1 ? 'es' : ''}`
                        : `${filteredResources.length} de ${resources.length} recurso${resources.length !== 1 ? 's' : ''}`
                    }
                </div>

                
            </div>
            
            
            <div className="overflow-x-auto text-left">
                <Table>
                    <TableHead>
                        <TableHeadCell className="text-left">Area</TableHeadCell>
                        <TableHeadCell className="text-left">Recurso</TableHeadCell>
                        <TableHeadCell className="text-left">Descripción</TableHeadCell>
                        <TableHeadCell className="text-left">Publicación</TableHeadCell>
                        <TableHeadCell className="text-left">Estado</TableHeadCell>
                        <PermissionWrapper requiredPermissions={['resource_action']}>
                          <TableHeadCell>
                              <span className="srOnly">Acción</span>
                          </TableHeadCell>
                        </PermissionWrapper>
                    </TableHead>
                    <TableBody className="divide-y">
                        {console.log("typeof filteredResources", typeof filteredResources, filteredResources)}
                        {Array.isArray(filteredResources) && filteredResources?.map((res) => (
                            <TableRow key={res.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {res.area?.name}
                                </TableCell>
                                <TableCell className="flex">
                                <a href="#" onClick={()=>handleDownload(res)}>
                                    <HiOutlineDownload className="w-12 text-blue-500 mr-3" title="Descargar recurso"/>
                                </a>
                                {res.fileName}
                                </TableCell>
                                <TableCell>{res.observation}</TableCell>
                                <TableCell>{res.formattedPublishDate}</TableCell>
                                <TableCell>{(parseInt(res.status)===1)?'Activo':'Inactivo'}</TableCell>
                                <PermissionWrapper requiredPermissions={['resource_action']}>
                                <TableCell className="inline-flex">
                                    <a href="#" onClick={()=>openModal("Editar recurso",res.id, false, res.fileName)}>
                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar recurso"/>
                                    </a>
                                    <a href="#" onClick={()=>handleRemove(res.id)}>
                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar recurso"/>
                                    </a>
                                </TableCell>
                                </PermissionWrapper>
                            </TableRow>
                        ))}
                        {filteredResources.length === 0 && (
                            <TableRow>
                                <TableCell colSpan="6" className="text-center py-8 text-gray-500">
                                    {searchTerm || selectedArea 
                                        ? "No se encontraron recursos con los filtros aplicados" 
                                        : "No hay recursos disponibles"
                                    }
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>

            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"lg"}>
                <FormResource onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} resourceId={resourceId} onClose={closeModal} resourceName={resourceName} isUpdating={isCreating?false:true}/>
            </Modals>
        </>
  )
}

export default Resources
